import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

interface AuthResponse {
  accessToken: string
  user: User
}

interface User {
  name: string
}

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://customer-auth.gyore-soma.workers.dev',
  }),
  endpoints: (builder) => ({
    signInWithGoogle: builder.mutation<AuthResponse, { code: string }>({
      query: ({ code }) => ({
        url: `/oauth2callback`,
        method: 'GET',
        params: { code },
      }),
    }),
  }),
})

export const { useSignInWithGoogleMutation } = authApi
